export default "__VITE_ASSET__i54a2FcG__"